import {Component, OnInit} from '@angular/core';
import {UploadLocation} from '../../enum/upload-location';
import {FileUploadService} from '../../services/file-upload-service/file-upload.service';
import {BinaryData} from '../../model/proposal/binary-data';
import {selectUserRoles} from '../../store/auth/selectors/auth.selectors';
import {Store} from '@ngrx/store';
import {UserAppState} from '../../store/user/reducers/user.reducer';
import {Roles} from '../../enum/roles';
import { MatSnackBar } from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'app-bill-board',
    templateUrl: './bill-board.component.html',
    styleUrls: ['./bill-board.component.scss', '../../../styles/form-input.scss', '../../../styles/edit-style.scss', '../../../styles/create-something.scss', '../../../styles/standard-elements.scss', '../../components/proposal-details-components/proposal-details-tab/proposal-details-expandable.component.scss'],
    standalone: false
})
export class BillBoardComponent implements OnInit{

  generalFiles: BinaryData[] = [];
  generalMeetingsFiles: BinaryData[] = [];
  authorisationsFiles: BinaryData[] = [];
  applicationsFiles: BinaryData[] = [];
  newFiles: BinaryData[] = [];

  companyName: string = '';
  companyLocation: string = '';
  exchangeVisitorName: string = '';
  selectedOption: string = 'membership'; // Default selection

  roles$ = this.userStore.select(selectUserRoles);

  constructor(private readonly fileUploadService: FileUploadService,
              private readonly userStore: Store<UserAppState>,
              private readonly translate: TranslateService,
              private readonly snackBar: MatSnackBar) {
    this.fileUploadService.emailSent.subscribe(() => {
      this.snackBar.open(this.translate.instant('billBoard.emailSent'), '', {
        duration: 3000,
        panelClass: ['success-snackbar', 'custom-snackbar']
      });
    });
  }

  ngOnInit(): void {
    this.fileUploadService.findBinaryData().subscribe(files => {
      this.generalFiles = files.filter(file => file.uploadLocation === UploadLocation.BILLBOARDGENERAL);
      this.generalMeetingsFiles = files.filter(file => file.uploadLocation === UploadLocation.BILLBOARDGENERALMEETINGS);
      this.authorisationsFiles = files.filter(file => file.uploadLocation === UploadLocation.BILLBOARDAUTHORISATIONS);
      this.applicationsFiles = files.filter(file => file.uploadLocation === UploadLocation.BILLBOARDAPPLICATIONS);
    });
  }

  protected readonly Roles = Roles;
  protected readonly UploadLocation = UploadLocation;


  hasOneNewApplicationFile(): boolean {
    return this.newFiles.filter(f => f.uploadLocation === UploadLocation.BILLBOARDAPPLICATIONS).length == 1;
  }

  sendMembershipEmail(): void {
    if (this.hasOneNewApplicationFile()){
      this.newFiles.filter(file => file.uploadLocation === UploadLocation.BILLBOARDAPPLICATIONS)
        .forEach(file => {
          this.fileUploadService.sendMembershipEmail(file.id, this.companyName, this.companyLocation);
        });
      this.companyName = '';
      this.companyLocation = '';
    }
  }

  sendExchangeVisitorEmail(): void {
    if (this.hasOneNewApplicationFile()) {
      this.newFiles.filter(file => file.uploadLocation === UploadLocation.BILLBOARDAPPLICATIONS)
        .forEach(file => {
          this.fileUploadService.sendExchangeVisitorEmail(file.id, this.companyName, this.exchangeVisitorName);
        });
      this.companyName = '';
      this.exchangeVisitorName = '';
    }
  }
}
